<template>
  <div>
    <div class="storage">
      <!-- 返回和介绍入口 -->
      <div
        class="storage-header"
        :style="{ paddingTop: 10.31 + statusBarHeight + 'px' }"
      >
        <div class="storage-header-return" @click="handleClosePage">
          <img
            :src="
              require('@/assets/images/YuliApp/weeklyTask/button_return.svg')
            "
          />
        </div>
        <div class="storage-header-introduce">
          <span>Rewards rules</span
          ><img
            @click="showActivityIntro"
            :src="require('@/assets/images/YuliApp/wenhao.png')"
          />
        </div>
      </div>

      <!-- 标题 -->
      <div class="storage-title">
        <div class="storage-title-image">
          <img
            :src="
              require('@/assets/images/YuliApp/storageActivity/title_bg.png')
            "
          />
        </div>
        <h1 class="storage-title-text">Growth Rewards</h1>
        <div class="storage-title-image">
          <img
            :src="
              require('@/assets/images/YuliApp/storageActivity/title_bg.png')
            "
          />
        </div>
      </div>

      <!-- 成长基金 -->
      <GrowthArg
        :redPoint_show="redPoint_show"
        :growth_arg="growth_arg"
        :gr_arg_usage="gr_arg_usage"
        @showConfig="handleShowConfig"
        @showList="handleShowConsumeList"
      ></GrowthArg>

      <!-- 规则 -->

      <p class="storage-rule">
        Growth rewards only apply to Yuli with rarity above common.
      </p>

      <!-- 缺省图展示 -->
      <div v-if="yuliData.length === 0 && loaded" class="storage-default">
        <div class="storage-default-image">
          <img
            :src="
              require('@/assets/images/YuliApp/storageActivity/img_robot@2x.png')
            "
          />
        </div>
        <p>So far, you haven't qualified Yuli yet.</p>
      </div>

      <!-- Yuli列表 -->
      <div v-else class="storage-yuliList">
        <YuliPrizeBlock
          v-for="item in yuliData"
          :key="item.token_id"
          :number="item.token_id"
          :arg_number="item.arg_number"
          :ticket_number="item.ticket_number"
          :role_sx_image="item.role_sx_image"
          :role_pz_image="item.role_pz_image"
          :role_property="item.role_property"
          :purify_count="item.purify_count"
          :total_goal_count="item.purify_goal_count"
          :isDraw="item.is_claimed"
          :claimed_time="item.claimed_time"
          @drawArg="drawArg"
          @drawError="drawError"
        ></YuliPrizeBlock>
      </div>
    </div>

    <!-- 活动详情弹窗 -->
    <ActivityIntro
      v-if="show_activity_intro"
      @close="handleCloseIntro"
    ></ActivityIntro>

    <!-- 提取成功弹窗 -->
    <DrawPopup
      v-if="show_draw_activity"
      @close="handleClosePopup"
      :title="'Prizes Reward'"
    >
      <!-- 奖励内容 -->
      <div class="popup-reward">
        <div class="popup-reward-arg">
          <p class="popup-reward-arg-number">{{ cur_draw_number }}</p>
        </div>
        <!-- <div class="popup-reward-ticket">
          <p class="popup-reward-ticket-number">{{ cur_draw_ticket }}</p>
        </div> -->
      </div>
    </DrawPopup>

    <!-- 提取出错弹窗 -->
    <DrawErrorPopup
      v-if="show_draw_error"
      @close="handleCloseErrorPopup"
    ></DrawErrorPopup>

    <!-- 成长基金配置项 -->
    <GrowthConfig
      v-if="isShowGrowthConfig"
      :growth_select_items="growth_select_items"
      @close="handleShowConfig"
    ></GrowthConfig>

    <!-- 成长基金消耗记录 -->
    <ConsumeList
      :consume_list="consume_list"
      :consume_total="consume_total"
      v-if="isShowConsumeList"
      @close="handleShowConsumeList"
      @handleNext="handleNext"
    ></ConsumeList>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import ActivityIntro from "./components/ActivityIntro";
import YuliPrizeBlock from "./components/YuliPrizeBlock";
import DrawPopup from "@/components/DrawPopup";
import DrawErrorPopup from "./components/DrawErrorPopup";
import GrowthArg from "./components/GrowthArg";
import GrowthConfig from "./components/GrowthConfig";
import ConsumeList from "./components/ConsumeList";
import _ from "lodash";
import {
  getSprintSaving,
  getGrowthRewardConfig,
  postGrowthRewardConfig,
  getGrowthReward,
  getConsumeList,
} from "@/api/activity.js";
import { getUtcTime } from "@/utils/time.js";
import {
  PZ_TYPE_NAME,
  YULI_SX_TYPE,
  YULI_PZ_TYPE,
  PRIZE_TYPE,
  TICKET_TYPE,
} from "./constants/storagePrize";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
  components: {
    ActivityIntro,
    YuliPrizeBlock,
    DrawPopup,
    DrawErrorPopup,
    GrowthArg,
    GrowthConfig,
    ConsumeList,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      tokenIds: (state) => state.global.tokenIds,
    }),
  },
  watch: {
    init: {
      handler(value) {
        if (!value) {
          return;
        }
        appBridging.getTokenIds();
        this.isInit = value;
      },
      immediate: true,
      deep: true,
    },
    tokenIds: {
      handler(value) {
        if (value === "空") {
          this.loaded = true;
          appBridging.closeLoading();
        } else if (value && value.length && this.isInit) {
          this.init(value);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const show_activity_intro = ref(false);
    const show_draw_activity = ref(false);
    const show_draw_error = ref(false);

    const cur_draw_number = ref(""); //当前提取的arg数量
    const cur_draw_ticket = ref(""); //当前提取的ticket数量
    const yuliData = ref([]);
    const isInit = ref(false);
    const loaded = ref(false); //判断是否加载完成
    const cur_error_id = ref(0); //当前提取失败的yuli id
    const growth_arg = ref(""); //成长基金
    const growth_select_items = ref([]); //成长基金优先选项
    const gr_arg_usage = ref(""); //已使用的成长基金

    const isShowGrowthConfig = ref(false);
    const isShowConsumeList = ref(false);

    const consume_list = ref([]); //基金消耗记录
    const consume_total = ref(0);
    const offset = ref(0);

    const redPoint_show = ref(false); // 红点展示
    const next_page = ref(false);

    const tokenIdList = ref([]);
    const attribute_obj = ref(null);

    onMounted(() => {
      appBridging.getStatusBarHeight();
      // init();
      // appBridging.closeLoading();
    });

    /**
     * 初始化
     */
    const init = async (tokenIds) => {
      //接收客户端过来的数据进行处理
      const { token_id_list, attributeObj } = getAttributesAll(tokenIds);

      tokenIdList.value = token_id_list;
      attribute_obj.value = attributeObj;

      await initYuliList(tokenIdList.value, attribute_obj.value);

      loaded.value = true;
      appBridging.closeLoading();

      await initGrowthConfigAndConsume();
    };

    /**
     * 初始化请求yuli列表
     */
    const initYuliList = async (token_id_list, attributeObj) => {
      //请求净化进度等数据、过滤灰色盒子
      const dataList = await requestGetYuliId(token_id_list);

      //请求成长基金
      await requestGetGrowthReward();

      //数据为空返回
      if (dataList.length === 0) {
        return;
      }

      //合并
      yuliData.value = handleYuliData(dataList, attributeObj);

      //重新排序
      yuliData.value = sortData(yuliData.value);
    };

    /**
     * 初始化配置项和消耗记录请求
     */
    const initGrowthConfigAndConsume = async () => {
      proxy.$loading.show();
      await requestGetGrowthRewardConfig();
      await requestGetConsumeList();
      proxy.$loading.hide();
    };

    /**
     * 处理客户端所有角色数据
     */
    const getAttributesAll = (attributesAll) => {
      const token_id_list = [];
      let attributeObj = {};
      attributesAll.forEach((item, index) => {
        token_id_list.push(item.token_id);
        const level = _.get(item.extension, "level", "");
        const role_property = _.get(item.extension, "role_property", "");
        const role_type = _.get(item.extension, "role_type", "");

        const attributes = {
          role_property: role_property,
          role_type: role_type,
          level: level,
        };

        attributeObj[item.token_id] = attributes;
      });
      return {
        token_id_list,
        attributeObj,
      };
    };

    /**
     * 请求Yuli id列表
     */
    const requestGetYuliId = (tokenIds) => {
      const pramas = {
        token_ids: tokenIds.join(","),
      };
      return getSprintSaving(pramas)
        .then((res) => {
          const data = _.get(res, "data", []) || [];

          const grArgUsage = _.get(res, "gr_arg_usage", "0") || "0";
          const first_setup = _.get(res, "first_setup", false);

          gr_arg_usage.value = grArgUsage;
          redPoint_show.value = first_setup;

          return data;
        })
        .catch((error) => {
          return [];
        });
    };

    /**
     * 重新排序 未被领取的
     */
    const sortData = (data) => {
      const onProgress = [];
      const not_claimed = [];
      const claimed = [];

      //过滤已被领取的、未被领取满级的、不到30级的
      data.forEach((item, index) => {
        if (
          item.is_claimed === false &&
          item.purify_count >= item.purify_goal_count
        ) {
          not_claimed.push(item);
        } else if (item.is_claimed === true) {
          claimed.push(item);
        } else {
          onProgress.push(item);
        }
      });

      //过滤中间的
      const on_progress = onProgress.sort((a, b) => {
        if (a.purify_count < b.purify_count) {
          return 1;
        }
        if (a.purify_count > b.purify_count) {
          return -1;
        }
        return 0;
      });

      return not_claimed.concat(on_progress).concat(claimed);
    };

    /**
     * 处理yuli数据列表
     */
    const handleYuliData = (yuliData, attributeObj) => {
      const dataList = [];
      yuliData.forEach((item, index) => {
        const attribute = attributeObj[item.token_id];
        const obj = {
          token_id: item.token_id,
          arg_number: attribute ? PRIZE_TYPE[attribute.role_type] : "",
          ticket_number: attribute ? TICKET_TYPE[attribute.role_type] : "",
          role_sx_image: attribute ? YULI_SX_TYPE[attribute.role_property] : "",
          role_pz_image: attribute ? YULI_PZ_TYPE[attribute.role_type] : "",
          role_property: attribute ? PZ_TYPE_NAME[attribute.role_property] : "",
          purify_count: attribute.level,
          is_claimed: item.is_claimed,
          purify_goal_count: 30,
          claimed_time: getUtcTime(item.claimed_at * 1000, "YYYY/M/D"),
        };
        dataList.push(obj);
      });

      return dataList;
    };

    /**
     * 请求成长基金
     */
    const requestGetGrowthReward = () => {
      return getGrowthReward().then((res) => {
        const growthArg = _.get(res, "data.gr_arg", "0") || "0";
        growth_arg.value = growthArg;
      });
    };

    /**
     * 请求成长基金配置项
     */
    const requestGetGrowthRewardConfig = () => {
      return getGrowthRewardConfig().then((res) => {
        const growthSelectItems = _.get(res, "data", []);
        growth_select_items.value = growthSelectItems;
      });
    };

    /**
     * 请求成长基金消耗记录
     */
    const requestGetConsumeList = () => {
      const params = {
        page_size: 10,
        offset: offset.value,
      };
      return getConsumeList(params).then((res) => {
        const consumeList = _.get(res, "data", []) || [];
        const total = _.get(res, "total", 0);
        const _offset = _.get(res, "offset", 0);

        consumeList.length &&
          !consume_list[next_page.value] &&
          consume_list.value.push(consumeList);

        consume_total.value = total;
        _offset ? (offset.value = _offset) : "";
      });
    };

    /**
     * 处理下一页请求
     */
    const handleNext = async (nextPage) => {
      next_page.value = nextPage;

      proxy.$loading.show();
      await requestGetConsumeList();
      proxy.$loading.hide();
    };

    /**
     * 活动介绍
     */
    const showActivityIntro = () => {
      show_activity_intro.value = true;
    };
    const handleCloseIntro = () => {
      show_activity_intro.value = false;
    };

    /**
     * 提取arg传值
     */
    const drawArg = (arg_number, ticket_number) => {
      cur_draw_number.value = arg_number;
      cur_draw_ticket.value = ticket_number;
      show_draw_activity.value = true;
    };

    /**
     * 关闭提取arg弹窗
     */
    const handleClosePopup = async () => {
      show_draw_activity.value = false;

      appBridging.handleRefreshNativeCache('V1GetWallet');
      //刷新成长基金和yuli列表
      await initYuliList(tokenIdList.value, attribute_obj.value);
    };

    /**
     * 展示提取失败弹窗
     */
    const drawError = (token_id) => {
      show_draw_error.value = true;
      cur_error_id.value = token_id;
      // console.log("cur_error_id", token_id);
    };

    /**
     * 关闭提取失败弹窗
     */
    const handleCloseErrorPopup = () => {
      show_draw_error.value = false;

      const cur_error_index = yuliData.value.findIndex(
        (item) => item.token_id === cur_error_id.value
      );
      cur_error_index !== -1 ? yuliData.value.splice(cur_error_index, 1) : "";

      // console.log("cur_error_index", yuliData.value, cur_error_index);
    };

    /**
     * 关闭页面
     */
    const handleClosePage = () => {
      appBridging.closePage();
    };

    /**
     * 控制展示成长基金设置项
     */
    const handleShowConfig = async (state, isRefresh) => {
      isShowGrowthConfig.value = state;
      if (!state && isRefresh === "refresh") {
        proxy.$toast.show({
          msg: "Setting operation succeeded.",
          type: TOAST_TYPE.SUCCESS,
        });
        /**
         * 通知移动端获取数据
         */
        appBridging.handleRefreshNativeCache('V1GetWalletGrPreference');
        redPoint_show.value = false;
        await requestGetGrowthRewardConfig();
        await requestGetGrowthReward();
      }
    };

    /**
     * 控制展示消耗记录
     */
    const handleShowConsumeList = (state) => {
      isShowConsumeList.value = state;
    };

    return {
      show_activity_intro,
      showActivityIntro,
      show_draw_activity,
      show_draw_error,
      handleCloseIntro,
      yuliData,
      drawArg,
      handleClosePopup,
      cur_draw_number,
      cur_draw_ticket,
      init,
      handleClosePage,
      isInit,
      loaded,
      handleCloseErrorPopup,
      drawError,
      growth_arg,
      gr_arg_usage,
      isShowGrowthConfig,
      handleShowConfig,
      handleShowConsumeList,
      isShowConsumeList,
      growth_select_items,
      consume_list,
      consume_total,
      handleNext,
      redPoint_show,
    };
  },
};
</script>

<style lang="less" scoped>
h1,
p,
img {
  margin: 0;
  padding: 0;
}
.storage {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-image: url("~@/assets/images/YuliApp/storageActivity/bg_storage@2x.png");
  background-size: 100% 100%;
  overflow: hidden;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 16px;
    &-return {
      width: 64.07px;
      height: 30px;
      text-align: left;
      img {
        width: 100%;
        height: 100%;
        margin-left: -4px;
      }
    }
    &-introduce {
      position: relative;
      width: 105px;
      height: 20px;
      border-radius: 22px;
      background: rgba(50, 57, 81, 1);
      box-shadow: inset 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      span {
        position: absolute;
        left: 49%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: rgba(187, 187, 187, 1);
        font-size: 12px;
        font-weight: 400;
        font-family: "PingFang HK";
        text-align: center;

        white-space: nowrap;
      }
      img {
        position: absolute;
        top: 50%;
        right: -3px;
        transform: translate(0, -50%);

        width: 24px;
        height: 24px;
        margin-right: -8px;
      }
    }
  }

  &-title {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 15px;
    &-image {
      position: relative;
      width: 254px;
      height: 5px;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
      }
    }
    &-text {
      color: rgba(163, 188, 214, 1);
      font-size: 18px;
      font-weight: 500;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 21.6px;
      margin: 4px 0;
    }
  }

  &-rule {
    margin: 0 auto;
    width: 295px;
    height: 30px;
    opacity: 0.9;
    color: rgba(153, 211, 255, 1);
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFang HK";
    text-align: center;
    line-height: 15.06px;
  }
  &-yuliList {
    flex-grow: 1;
    margin-top: 13px;
    margin-bottom: 2px;
    // padding-top: 39px;
    overflow-y: scroll;
  }
  //隐藏滚动条
  .storage-yuliList::-webkit-scrollbar {
    display: none;
  }
  .storage-yuliList {
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: auto;
  }
  &-default {
    margin-top: 70px;
    text-align: center;
    &-image {
      margin: 0 auto;
      width: 130px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    p {
      color: rgba(128, 142, 182, 1);
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 17.57px;
    }
  }
}
.popup-reward {
  position: absolute;
  top: 169px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: center;
  &-arg,
  &-ticket {
    position: relative;
    width: 82px;
    height: 82px;
    background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/reward_arg_big@2x.png");
    background-size: 100% 100%;
    text-align: center;
    &-number {
      height: 25.6px;
      position: absolute;
      bottom: 3px;
      left: 50%;
      transform: translate(-50%, 0);
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      font-weight: 500;
      font-family: "PingFang SC";
      text-align: center;
      line-height: 24.6px;
      letter-spacing: 0.91px;
    }
  }
  &-ticket {
    margin-left: 10px;
    background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/reward_ticket_big@2x.png");
  }
}
</style>
